import React from 'react';
import { Link } from 'react-router-dom';

const ServicesCTABanner = () => {
    return (
        <>
            <section className="cta-banner">
                {/* Floating Shapes for background depth */}
                <div className="cta-shape cta-shape-1"></div>
                <div className="cta-shape cta-shape-2"></div>

                <div className="container text-center cta-content">
                    <p className="cta-subtitle">
                        Unlock Your Potential
                    </p>
                    <h2 className="cta-title">
                        Let's Innovate & Grow Together
                    </h2>
                    <p className="cta-description text-center">
                        From groundbreaking software solutions to captivating digital experiences and strategic marketing, our team is ready to partner with you. Let's transform your challenges into opportunities for unprecedented growth.
                    </p>
                    <Link
                        to="/contact-us"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        className="cta-button"
                    >
                        Start Your Project
                    </Link>
                </div>
            </section>

            <style>{`
                /* =============================================
                   INNOVATIVE CTA BANNER
                   ============================================= */

                .cta-banner {
                    position: relative;
                    padding: 100px 0;
                    background-color: #110723; /* Dark background consistent with other sections */
                    overflow: hidden;
                }

                .cta-content {
                    position: relative;
                    z-index: 2;
                }

                .cta-subtitle {
                    color: #ffb428; /* Gold accent color */
                    font-weight: 600;
                    font-size: 1.1rem;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                    margin-bottom: 1rem;
                    text-align: center;
                }

                .cta-title {
                    font-size: 3.5rem;
                    font-weight: 800;
                    line-height: 1.2;
                    margin-bottom: 1.5rem;
                    /* Gradient text for a premium feel */
                    background: linear-gradient(90deg, #ffffff, #d0d0d0);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .cta-description {
                    max-width: 750px;
                    margin: 0 auto 2.5rem auto;
                    font-size: 1.2rem;
                    line-height: 1.8;
                    color: #c0c0c0; /* Softer white for description */
                }

                .cta-button {
                    display: inline-block;
                    background: linear-gradient(90deg, #a04ff4, #8e2de2);
                    color: #fff;
                    font-weight: 600;
                    font-size: 1.2rem;
                    border-radius: 50px;
                    padding: 16px 35px;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 20px rgba(160, 79, 244, 0.3);
                }

                .cta-button:hover {
                    transform: scale(1.05) translateY(-3px);
                    box-shadow: 0 8px 30px rgba(160, 79, 244, 0.4);
                }

                /* --- Floating Aurora Shapes --- */
                .cta-shape {
                    position: absolute;
                    border-radius: 50%;
                    filter: blur(100px);
                    z-index: 1;
                    pointer-events: none;
                }

                .cta-shape-1 {
                    width: 300px;
                    height: 300px;
                    background: rgba(160, 79, 244, 0.2);
                    top: -80px;
                    left: -80px;
                }

                .cta-shape-2 {
                    width: 350px;
                    height: 350px;
                    background: rgba(255, 180, 40, 0.15);
                    bottom: -100px;
                    right: -100px;
                }

                /* --- Responsive Design --- */
                @media (max-width: 768px) {
                    .cta-banner {
                        padding: 80px 15px;
                    }
                    .cta-title {
                        font-size: 2.5rem;
                    }
                    .cta-description {
                        font-size: 1.1rem;
                    }
                }
            `}</style>
        </>
    );
};

export default ServicesCTABanner;